import { Img } from 'remotion';
import { AudiogramProps } from '../schema';

export function Header({ coverImageUrl, titleColor, titleText, variant }: AudiogramProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      {variant === '9x16' ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            marginTop: '30%',
            width: '100%',
          }}
        >
          <Img
            style={{
              borderRadius: '8px',
              maxHeight: '160px',
              marginBottom: '64px',
            }}
            src={coverImageUrl}
          />
          <div
            style={{
              lineHeight: '1.25',
              fontWeight: 800,
              color: titleColor,
              fontSize: '48px',
              textAlign: 'center',
            }}
          >
            {titleText}
          </div>
        </div>
      ) : (
        <>
          <Img
            style={{
              borderRadius: '8px',
              maxHeight: '250px',
            }}
            src={coverImageUrl}
          />
          <div
            style={{
              marginLeft: '48px',
              lineHeight: '1.25',
              fontWeight: 800,
              color: titleColor,
              fontSize: '48px',
            }}
          >
            {titleText}
          </div>
        </>
      )}
    </div>
  );
}
